// Auto generated file, do not manually modify!
// com.hotpads.maintenancetracker.client.maintenance.lessenpilot.enums.LessenPilotEligibilityState

export enum LessenPilotEligibilityState {
  LAUNCHED = 'LAUNCHED',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  WAITLIST = 'WAITLIST',
}

export const LessenPilotEligibilityState_values = [
  LessenPilotEligibilityState.LAUNCHED,
  LessenPilotEligibilityState.NOT_ELIGIBLE,
  LessenPilotEligibilityState.WAITLIST,
] as const;
